export const getGameTime = (state) => state.timeGame.time;